import { createContext, useContext, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertiesContext = /*#__PURE__*/createContext({
  properties: {}
});
const PropertiesProvider = ({
  properties = {},
  ...rest
}) => /*#__PURE__*/_jsx(PropertiesContext.Provider, {
  value: {
    properties
  },
  ...rest
});
const useProperty = () => {
  const context = useContext(PropertiesContext);
  if (!context) {
    throw new Error('useProperties must be used within a PropertiesProvider');
  }
  return {
    p: useCallback(value => context.properties[value], [context.properties])
  };
};
export { PropertiesProvider, useProperty };
//# sourceMappingURL=PropertiesContext.js.map